<article>
    <div>
        <h1>AIROV Homepage Admin Code</h1>
        <button (click)="saveCode()">저장</button>
    </div>
    <div class="box">
        관리자 코드 현재<br>
        <div>{{adminCode}}</div>
    </div>
    <div class="box">
        관리자 코드 변경<br>
        <textarea id="change-code" name="change-code" cols="50" rows="1" wrap="physical"></textarea>
    </div>
</article>